module.exports = ArcoVueIcon;